var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMap = function SvgMap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 .27.44 2.14c-.12.04-.19.13-.19.24V17.5c0 .14.11.25.25.25l.11-.03 5.38-2.09 6.01 2.1 5.56-1.87c.09-.03.19-.11.19-.24V.5c0-.14-.1-.24-.23-.25l-.13.02-5.38 2.09L6 .27Zm6.75 15.63V3.69l3.5-1.35v12.38l-3.5 1.18Zm-1.5-.01-4.5-1.58V2.12l4.5 1.58v12.19Zm-9.5-.21V3.28l3.5-1.18v12.22l-3.5 1.35v.01Z",
    fill: "#D64309"
  })));
};
export default SvgMap;